// import React from "react";
// import Banner from "../../Assets/Hero-image.JPG";
// // import ZigZagLine from "./Zigzag";

// const HeroSection = () => {
//   return (
//     <div className="relative  ">
//       {/* Background Image */}
//       <div className="w-full h-[900px] overflow-hidden -mt-24 ">
//         <img
//           src={Banner}
//           alt="Hero Section Banner"
//           className="w-full h-full object-cover brightness-50 "
//         />
//       </div>

//       {/* Zigzag Image */}
//       <div className="absolute top-[400px] left-[75%] z-20 mt-72 rotate-45">
//         <img
//           src="https://static.showit.co/400/D0hghjfYR0yp5pRJwcqjHw/51489/doodle_8.png"
//           alt="Decorative Zigzag"
//           className="w-[200px] h-auto"
//         />
//       </div>

//       {/* Card Section */}
//       <div className="absolute bottom-[-60px] left-[calc(30%-160px)] bg-white w-[50%] h-[620px] max-w-[650px] shadow-lg p-10 z-20 flex flex-col">
//         <div className="p-8">
//           <h4
//             className="text-xl font-thin mb-12 text-left tracking-widest"
//             style={{ fontFamily: "'Blacker Pro Display Light'" }}
//           >
//             Connect Engage Grow
//           </h4>
//           <h2
//             className="text-5xl font-thin mb-12 text-left mt-3 italic leading-[55px]"
//             style={{ fontFamily: "'Blacker Pro Display Light'" }}
//           >
//             A Creative Studio bringing your vision to life, giving your brand
//             identity through timeless designs and impactful storytelling
//           </h2>
//         </div>
//         <button className="bg-[#704735] text-white px-4 py-4 rounded-md text-sm cursor-pointer self-start -mt-9 ml-7">
//           ENROLL NOW
//         </button>
//       </div>

//       {/* Decorative Gradient Element */}
//       {/* <div className="z-20 relative" ><ZigZagLine/></div> */}
//       {/* <div className="relative">
//         <div className="absolute w-full z-20">
//           <ZigZagLine />
//         </div>
//       </div> */}
//     </div>
//   );
// };

// export default HeroSection;
import React from "react";
import { Link } from "react-router-dom";
import Banner from "../../Assets/Hero-image.jpg";

const HeroSection = () => {
  return (
    <div className="relative">
      {/* Background Image */}
      <div className="w-full h-[500px] sm:h-[400px] md:h-[600px] lg:h-[700px] overflow-hidden -mt-24">
        <img
          src={Banner}
          alt="Hero Section Banner"
          className="w-full h-full object-cover brightness-50"
        />
      </div>

      {/* Zigzag Image - Hidden on mobile, visible on larger screens */}
      <div className="hidden md:block absolute top-[350px] left-[75%] z-20 mt-48 rotate-45 transform-gpu">
        <img
          src="https://static.showit.co/400/D0hghjfYR0yp5pRJwcqjHw/51489/doodle_8.png"
          alt="Decorative Zigzag"
          className="w-[80px] md:w-[120px] lg:w-[150px] h-auto"
        />
      </div>

      {/* Card Section */}
      <div
        className="absolute bottom-[-70px] sm:bottom-[-50px] md:bottom-[-30px] lg:bottom-[-40px] 
                    left-12 sm:left-8 md:left-[calc(30%-140px)] 
                    bg-white 
                    w-[75%] sm:w-[70%] md:w-[55%] lg:w-[45%] 
                    h-auto sm:h-auto md:h-[420px] lg:h-[520px] 
                    max-w-[550px] 
                    shadow-lg 
                    p-4 sm:p-5 md:p-7 lg:p-8 
                    z-20 
                    flex flex-col"
      >
        <div className="p-2 sm:p-3 md:p-5">
          <h4
            className="text-base sm:text-sm md:text-lg 
                     font-thin mb-6 sm:mb-4 md:mb-6 lg:mb-8 
                     text-left tracking-widest"
            style={{ fontFamily: "'Blacker Pro Display Light'" }}
          >
            Connect Engage Grow
          </h4>
          <h2
            className="text-2xl sm:text-xl md:text-3xl lg:text-4xl 
                     font-thin 
                     mb-6 sm:mb-4 md:mb-6 lg:mb-8 
                     text-left mt-2 sm:mt-1 md:mt-2 
                     italic 
                     leading-normal md:leading-relaxed lg:leading-[45px]"
            style={{ fontFamily: "'Blacker Pro Display Light'" }}
          >
            A Creative Studio bringing your vision to life, giving your brand
            identity through timeless designs and impactful storytelling
          </h2>
        </div>
        <Link to="/booking">
          <button
            className="bg-[#704735] 
                         text-white 
                         px-3 py-2 sm:px-4 sm:py-3 
                         rounded-md 
                         text-xs sm:text-sm 
                         cursor-pointer 
                         self-start 
                         -mt-4 sm:-mt-3 md:-mt-7 
                         ml-4 sm:ml-3 md:ml-6
                         hover:bg-[#5a3829] transition-colors"
          >
            Book an Appointment
          </button>
        </Link>
      </div>
    </div>
  );
};

export default HeroSection;
